import { Component, EventEmitter, Output } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

/**
 * Component used for the exclusion modal
 */
@Component({
  selector: 'app-exclusion-modal',
  template: `
    <div>
      <div style="display: flex; align-items: flex-start; margin-bottom: 16px;">
        <span style="color: #faad14; font-size: 24px; margin-right: 8px;">
          <i nz-icon nzType="warning" nzTheme="fill"></i>
        </span>
        <span>You are about to exclude transaction(s) from SST Deemed Payment / Payment Recovery.</span>
      </div>

      <div style="margin-bottom: 8px;">Please indicate reason for exclusion:</div>
      <textarea [(ngModel)]="reason" nz-input class="form-control" rows="3" style="width: 100%; margin-bottom: 16px;"></textarea>

      <div style="margin-bottom: 24px;">
        <span style="font-weight: bold;">Note:</span> The above reason will be applied to all selected transactions. You can still update for individual records in the "Excluded Records" tab.
      </div>
    </div>
    
    <div *nzModalFooter style="text-align: right;">
      <button 
        nz-button 
        nzType="default" 
        style="margin-right: 8px;" 
        (click)="handleCancel()">
        Cancel
      </button>
      <button 
        nz-button 
        nzType="primary"  
        (click)="handleOk()">
        Confirm Exclusion
      </button>
    </div>
  `,
  standalone: false
})
export class ExclusionModalComponent {
  reason: string = '';
  
  @Output() readonly confirmed = new EventEmitter<string>();
  
  constructor(private modalRef: NzModalRef) {}
  
  handleOk(): void {
    this.confirmed.emit(this.reason || 'Manually excluded');
    this.modalRef.close();
  }
  
  handleCancel(): void {
    this.modalRef.close();
  }
} 